export default __webpack_public_path__ + "static/media/MicrosoftTeams.af3cd5f7.png";